import { Controller } from "@hotwired/stimulus"
import { lockScroll, unlockScroll } from "../utils/scroll_lock"

export default class extends Controller {
  static targets = [
    "priceAdjustModal",
    "modalProductName",
    "modalOriginalPrice",
    "adjustedPrice",
    "discountReason",
    "submitPriceAdjust"
  ]
  static values = { salesOrderId: Number }

  connect() {
    this.currentLineItemId = null
  }

  // Price Adjustment Modal Methods
  showPriceAdjustModal(event) {
    const button = event.currentTarget
    this.currentLineItemId = button.dataset.lineItemId
    const productName = button.dataset.productName
    const originalPrice = parseFloat(button.dataset.originalPrice)

    this.modalProductNameTarget.textContent = productName
    this.modalOriginalPriceTarget.textContent = `$${originalPrice.toFixed(2)}`
    this.adjustedPriceTarget.value = originalPrice.toFixed(2)
    this.discountReasonTarget.value = ""
    this.priceAdjustModalTarget.classList.remove("hidden")
    lockScroll()
  }

  hidePriceAdjustModal() {
    this.priceAdjustModalTarget.classList.add("hidden")
    unlockScroll()
    this.currentLineItemId = null
  }

  async submitPriceAdjustment() {
    const adjustedPrice = this.adjustedPriceTarget.value
    const discountReason = this.discountReasonTarget.value.trim()

    if (!adjustedPrice || !discountReason) {
      return
    }

    if (parseFloat(adjustedPrice) < 0) {
      return
    }

    const submitBtn = this.submitPriceAdjustTarget
    const originalText = submitBtn.textContent
    submitBtn.textContent = "Applying..."
    submitBtn.disabled = true

    try {
      const response = await fetch(`/sales_orders/${this.salesOrderIdValue}/adjust_line_item_price`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]').getAttribute("content")
        },
        body: JSON.stringify({
          line_item_id: this.currentLineItemId,
          adjusted_price: adjustedPrice,
          discount_reason: discountReason
        })
      })

      const data = await response.json()
      if (data.success) {
        location.reload()
      }
    } catch (error) {
      console.error("Error:", error)
    } finally {
      submitBtn.textContent = originalText
      submitBtn.disabled = false
      this.hidePriceAdjustModal()
    }
  }

  async removePriceAdjustment(event) {
    const lineItemId = event.currentTarget.dataset.lineItemId

    try {
      const response = await fetch(`/sales_orders/${this.salesOrderIdValue}/remove_price_adjustment`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]').getAttribute("content")
        },
        body: JSON.stringify({
          line_item_id: lineItemId
        })
      })

      const data = await response.json()
      if (data.success) {
        location.reload()
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }

  priceAdjustModalBackdropClick(event) {
    if (event.target === this.priceAdjustModalTarget) {
      this.hidePriceAdjustModal()
    }
  }
}
